import { components } from 'react-select';
import { withClassName } from '../helpers';
export const GenericSelectControlPlaceholder = withClassName(components.Placeholder, 'placeholder');